// Ported from NearpodNext's `src/helpers/loadScript.js`, converted to TS and extended with
// referrerPolicy.
//
// Generic <script> injector: no CDN URLs, no deduplication. Callers that need
// "load once per page" own that state themselves.

interface ILoadScriptOptions {
	referrerPolicy?: ReferrerPolicy
}

const loadScript = (src: string, options: ILoadScriptOptions = {}): Promise<void> => {
	return new Promise((resolve, reject) => {
		const script = document.createElement('script')
		script.src = src
		if (options.referrerPolicy) {
			script.referrerPolicy = options.referrerPolicy
		}
		script.onload = () => resolve()
		script.onerror = () => reject(new Error(`Failed to load script: ${src}`))
		document.head.appendChild(script)
	})
}

export default loadScript
